import ko from 'knockout';
import $ from 'jquery';
import FormatterCommon from './formatter-common';
import LineChartFormatterCommon from './linechart-formatter-common';

    function LicenseLineChartFormatter(params, observableOptions) {

        var self = this;

        self.observableOptions = observableOptions;

        self.formatterCommon = FormatterCommon;
        self.lineChartFormatterCommon = new LineChartFormatterCommon();

        self.observableFormattedData = ko.observable({});

        self.subscriptions = [];
    }

    function ComposeData(formatterCommon, chartformatterCommon, sourcelist, options, initFlag) {
        if ($.isEmptyObject(sourcelist)) {
            return {
                pointDot: true,
                max: 10,
                replaceMode: false,
                xaxislabels: [],
                legend: [],
                legendColors: chartformatterCommon.linechartcolorlist,
                lines: [],
                data: [], //series1-label1-val1, series1-label2-val2, series2-label1-val3, ...
                strokeColors: [formatterCommon.RED, formatterCommon.BLUE]
            };
        } else {

            var initlabels = chartformatterCommon.GenerateTimeline(8); // => ! NOTE: when this is changed, the shift logic for summarydata should change as well

            /*var initlabels = ["-8 min", "-7 min", "-6 min", "-5 min", "-4 min", "-3 min", "-2 min", "-1 min", "Now"];*/
            var lines = ["Bridges", "Call Controls"];
            var filteredlines = lines;
            var linechartdata = [];
            var max = initlabels.length;//33

            //if (initFlag) {
            for (var i = 0; i < lines.length; i++) {
                linechartdata[i] = [];
                for (var j = 0; j < max; j++) {
                    linechartdata[i].push(null);
                }
            }
            //}

            if (options && options.filter) {
                filteredlines = chartformatterCommon.getLines(lines, options);
            }

            var startindex = 0;

            if (sourcelist.length > max) {
                startindex = sourcelist.length - max;
            }

            for (var k = startindex; k < sourcelist.length; k++) {

                var newvalues = [];

                if ($.inArray("Bridges", filteredlines) > -1) {

                    var value = sourcelist[k].BridgeLicenseUsage;

                    if (options && options.display && options.display.toUpperCase() == "AVAILABLE") {
                        value = 1 - value;
                    }

                    newvalues.push([Math.round(value * 100)]);
                }

                if ($.inArray("Call Controls", filteredlines) > -1) {
                    var value2 = sourcelist[k].CallControlLicenseUsage;

                    if (options && options.display && options.display.toUpperCase() == "AVAILABLE") {
                        value2 = 1 - value2;
                    }

                    newvalues.push([Math.round(value2 * 100)]);
                }

                linechartdata = formatterCommon.shiftValues(linechartdata, newvalues);
            }

            return {
                pointDot: true,
                max: 10,
                replaceMode: true,
                xaxislabels: initlabels,
                xaxisstep: 4,
                drawYAxisLine: true,
                lines: filteredlines,
                legend: lines,
                legendColors: chartformatterCommon.getLegendColors(lines, filteredlines),
                data: linechartdata,
                strokeColors: chartformatterCommon.getLineColors(lines, filteredlines),
                scaleMax: 100,
                pointHitDetectionRadius: 10,
                labelsFilter: function (labelval, index) {
                    if ($(window).width() <= 991)
                        return (index % 8) !== 0;
                    else
                        return (index % 4) !== 0;
                },
                ylabelSuffix: "%"
            };
        }
    }

    LicenseLineChartFormatter.prototype.RefreshData = function () {
        var self = this;

        self.observableFormattedData(ComposeData(self.formatterCommon, self.lineChartFormatterCommon, self.sourceList(), self.observableOptions()));

    };

    LicenseLineChartFormatter.prototype.DataUpdated = function () {
        var self = this;
        self.RefreshData();
    };

    LicenseLineChartFormatter.prototype.OptionsUpdated = function () {
        var self = this;

        self.RefreshData();
    };

    LicenseLineChartFormatter.prototype.initialize = function (dataRepository) {
        var self = this;

        self.dataRepository = dataRepository;

        self.sourceList = dataRepository.summaryData;

        self.subscriptions.push(self.sourceList.subscribe(function() { self.DataUpdated(); }));

        self.subscriptions.push(self.observableOptions.subscribe(function () { self.OptionsUpdated(); }));

        //initialize data if it is there, so that if it isn't a 'loading' icon will show on UI
        if (!$.isEmptyObject(self.sourceList()))
            self.RefreshData();
    };

    LicenseLineChartFormatter.prototype.getObservableData = function () {
        var self = this;

        return self.observableFormattedData;
    };

    LicenseLineChartFormatter.prototype.dispose = function() {
        var self = this;
        self.subscriptions.forEach(function (sub) {
            sub.dispose();
        });
    };

    export default LicenseLineChartFormatter;
